import callApi, { callManagerApi } from '../../util/apiCaller';
// import { userNotify } from '../../components/Toasts/ToastAdd';

export const SET_VM_CITY = 'SET_VM_CITY';
export const TOGGLE_AUTH_MODAL_STATE = 'TOGGLE_AUTH_MODAL_STATE';
export const TOGGLE_SEARCH_MODAL_STATE = 'TOGGLE_SEARCH_MODAL_STATE';
export const TOGGLE_SEARCH_MODAL_STATE_FOR_COMPARE_PAGE = 'TOGGLE_SEARCH_MODAL_STATE_FOR_COMPARE_PAGE';
export const TOGGLE_CITY_MODAL_STATE = 'TOGGLE_CITY_MODAL_STATE';
export const TOGGLE_SIDEMENU_STATE = 'TOGGLE_SIDEMENU_STATE';
export const SEARCHING_FOR_VENUES = 'SEARCHING_FOR_VENUES';
export const SEARCH_FOR_VENUES = 'SEARCH_FOR_VENUES';
export const GET_RECENT_SEARCHES = 'GET_RECENT_SEARCHES';
export const TOGGLE_GET_QUOTE_MODAL_STATE = 'TOGGLE_GET_QUOTE_MODAL_STATE';
export const SET_HEADER_POSITION = 'SET_HEADER_POSITION';

export function setHeaderPosition(status) {
  return (dispatch) => {
    dispatch({
      type: SET_HEADER_POSITION,
      isHeaderFixed: status,
    });
  };
}

export function setUserCity(cityslug) {
  return (dispatch) => {
    dispatch({
      type: SET_VM_CITY,
      selectedCity: cityslug,
    });
  };
}

export function fetchRecentSearches(recentSearches) {
  return {
    type: GET_RECENT_SEARCHES,
    recentSearches: recentSearches,
  };
}

export function toggleAuthModal(val, loginFormStateValue) {
  return (dispatch) => {
    dispatch({
      type: TOGGLE_AUTH_MODAL_STATE,
      isAuthModalVisible: !!val,
      loginFormState: loginFormStateValue,
    });
  };
}

export function toggleSearchModal(val) {
  return (dispatch) => {
    dispatch({
      type: TOGGLE_SEARCH_MODAL_STATE,
      isSearchModalVisible: !!val,
    });
  };
}

export function toggleSearchModalForComparePage(val) {
  return (dispatch) => {
    dispatch({
      type: TOGGLE_SEARCH_MODAL_STATE_FOR_COMPARE_PAGE,
      isSearchModalVisibleForComparePage: !!val,
    });
  };
}

export function toggleQuoteModal(val) {
  return (dispatch) => {
    dispatch({
      type: TOGGLE_GET_QUOTE_MODAL_STATE,
      isGetQuoteModalVisible: !!val,
    });
  };
}

export function toggleCityModal(val) {
  return (dispatch) => {
    dispatch({
      type: TOGGLE_CITY_MODAL_STATE,
      isCityModalVisible: !!val,
    });
  };
}

export function toggleSideMenuBarModal(val) {
  if(val) {
    document.body.setAttribute('style', 'overflow : hidden;');
  } else {
    document.body.setAttribute('style', 'overflow : visible;');
  }
  return (dispatch) => {
    dispatch({
      type: TOGGLE_SIDEMENU_STATE,
      isSideMenuBarVisible: !!val,
    });
  };
}

export function showLoaderForHeaderSearch() {
  return {
    type: SEARCHING_FOR_VENUES,
    isSearching: true,
  };
}

export function loadHeaderSearchData(data) {
  return {
    type: SEARCH_FOR_VENUES,
    isSearching: false,
    searchData: data,
  };
}


export function searchForVenuesByCityAndName(input) {
  return (dispatch) => {
    dispatch(showLoaderForHeaderSearch());
    return callManagerApi(`venues/search`, 'post', {
      term: input.term,
      cityslug: input.city,
      userid : input.userid,
      url: input.url,
    })
      .then(res => {
        if (res.data) {
          dispatch(loadHeaderSearchData(res.data.venues));
        } else {
          // dispatch(userNotify('Failed to load venues, please try again', 'error'));
        }
      });
  };
}

